import IMAGES from "@/assets/images";

const Loader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white dark:bg-slate-950 transition-colors duration-500 overflow-hidden">
      <div className="relative flex flex-col items-center gap-10">
        {/* Brand Name & Loading Indicator */}
        <div className="flex flex-col items-center gap-6">
          <div className="relative group">
            <div className="absolute inset-0 blur-3xl bg-theme-primary/30 rounded-full animate-pulse-glow" />
            <img
              src={IMAGES.mainLogo}
              alt="HRX Logo"
              className="relative w-28 h-28 md:w-36 md:h-36 object-contain animate-float"
            />
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="w-56 h-[3px] bg-slate-100 dark:bg-slate-800/50 rounded-full overflow-hidden shadow-inner">
              <div className="w-full h-full bg-gradient-to-r from-theme-primary/50 via-theme-primary to-theme-primary animate-loading-bar origin-left" />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-slate-400 dark:text-slate-500 text-[10px] font-bold tracking-[0.25em] uppercase">
                Synchronizing Workspace
              </span>
              <span className="flex gap-1">
                <span className="w-1 h-1 bg-theme-primary rounded-full animate-bounce [animation-delay:-0.3s]" />
                <span className="w-1 h-1 bg-theme-primary rounded-full animate-bounce [animation-delay:-0.15s]" />
                <span className="w-1 h-1 bg-theme-primary rounded-full animate-bounce" />
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Modern ambient blurred circles */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none -z-10">
        <div className="absolute -top-[10%] -left-[10%] w-[50%] h-[50%] bg-theme-primary/5 blur-[120px] rounded-full animate-pulse" />
        <div className="absolute -bottom-[10%] -right-[10%] w-[50%] h-[50%] bg-theme-primary/5 blur-[120px] rounded-full animate-pulse" />
      </div>

      {/* Subtle Bottom Attribution */}
      <div className="absolute bottom-8 text-slate-300 dark:text-slate-700 text-[9px] uppercase tracking-[0.4em] font-medium">
        Powered by UpscaleBD Ltd.
      </div>
    </div>
  );
};

export default Loader;
